export const getBreadCrumb = (page, name) => {
  const route = useRoute()
  if (page === 'top') {
    return [
      { text: '河川水位情報' }
    ]
  } else if (page === 'river') {
    return [
      { text: '河川水位情報', link: '/onebox/river/' },
      { text: pageConfig[route.params.rvrsys].name }
    ]
  } else if (page === 'point') {
    if (!route.params.rvrsys || !pageConfig[route.params.rvrsys]) {
      return [
        { text: '河川水位情報', link: '/onebox/river/' },
        { text: name }
      ]
    }
    return [
      { text: '河川水位情報', link: '/onebox/river/' },
      { text: `${pageConfig[route.params.rvrsys].name}水系`, link: `/onebox/river/${route.params.rvrsys}/` },
      { text: name }
    ]
  }
}
